import React, { useContext, useState, useEffect } from "react";
import { collection, query, where, onSnapshot, orderBy, limit } from "firebase/firestore";
import {FirebaseContext} from '../services/Firebase/Context';
import {AuthContext} from '../services/Session/Context';

const FeedbackBadge = (({ recordId }) => {
  const { user } = useContext(AuthContext);
  const { db } = useContext(FirebaseContext);
  const [fb, setFb] = useState(null);

  useEffect(() => {
    if(!user) return

    const q = query(collection(db, "feedbacks"), where("recordId", "==", recordId), where("organisationId", "==", user.organisationId), orderBy("date", 'desc'), limit(1));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      if (querySnapshot.size === 0) return
      const fb = querySnapshot.docs[0]
      setFb({
        id: fb.id,
        ...fb.data()
      });
    })
    return () => unsubscribe();
  }, [db, recordId, user])
  
  if(!fb) return null

  return (
    <span className={`
      rounded-xl
      relative
      p-2
      bg-${fb.global >= 4 ? 'green' : (fb.global <= 2 ? 'red' : 'yellow' )}-100
      ml-5
      text-xl
      font-bold
      text-${fb.global >= 4 ? 'green' : (fb.global <= 2 ? 'red' : 'yellow' )}-700
    `}>
      {fb.global}<span className='text-base font-normal'> / 5</span>
    </span>
  );
})

export default FeedbackBadge
